import type { FaireProductEntity } from "../../entity_types/product";

export const p_ddkpz5py7y: FaireProductEntity = {
  token: "p_ddkpz5py7y",
  type: "product",
  name: "Yellow Jasper, Periwinkle, + Oxblood Balance Earrings",
  brandToken: "b_fe0544c3",
  brandName: "Michelle Starbuck Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/18814a39a96a1772259ac6eaa1092f37fdf62389b2c7ade190ec62d2347d5e07.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ab609e66766faee8c9ce4d8f515dfd3c1715c873999a4852ccd7d5101c202a5f.jpeg",
    "https://cdn.faire.com/fastly/4408d93b7715607d79f1a0292cabb0b83f5513e002de434921665dbe4b888b20.jpeg",
    "https://cdn.faire.com/fastly/5e7ca106fb2b043cb413370ea0012d94158d758e81ca949d2c29e6e05fb5ad89.jpeg",
  ],
  priceDollars: 24,
  description:
    ' * Curved wire- choose between gold fill and brass\n * Yellow Jasper, Vintage Czech glass beads in periwinkle, oxblood, and amethyst\n * 14kt gold filled earhooks \n * Earrings are 1 3/4" long \n * Lightweight \n',
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:37:44.893Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
